import { authenticatedApi } from "../api";
import { MICROSERVICE_CONFIG } from "../../config/configs";

export const getAllRestaurants_api = async (params) => {
	const response = await authenticatedApi.get(
		`${MICROSERVICE_CONFIG.RESTAURANT}/restaurants?${params}`
	);
	return response.data;
};

export const getRestaurantDetails_api = async (id) => {
	if (id && id != "add") {
		const response = await authenticatedApi.get(
			`${MICROSERVICE_CONFIG.RESTAURANT}/restaurants/${id}`
		);
		return response.data;
	}
};

export const addRestaurant_api = async (body) => {
	const response = await authenticatedApi.post(
		`${MICROSERVICE_CONFIG.AUTH}/admin/add-restaurant`,
		body
	);
	return response.data;
};

export const addIntegration_api = async (body) => {
	const response = await authenticatedApi.post(
		`${MICROSERVICE_CONFIG.AUTH}/admin/add-integration`,
		body
	);
	return response.data;
};

export const updateRestaurant_api = async ({ id, fileData }) => {
	const response = await authenticatedApi.patch(
		`${MICROSERVICE_CONFIG.RESTAURANT}/restaurants/${id}`,
		fileData,
		{ headers: { "Content-Type": "multipart/form-data" } }
	);
	return response.data;
};

export const deleteRestaurant_api = async (id) => {
	const response = await authenticatedApi.delete(
		`${MICROSERVICE_CONFIG.RESTAURANT}/restaurants/${id}`
	);
	return response.data;
};

export const updateRestaurantContact_api = async ({ id, body }) => {
	const response = await authenticatedApi.patch(
		`${MICROSERVICE_CONFIG.AUTH}/admin/profile/${id}?role=restaurant`,
		body
	);
	return response.data;
};

export const updateRestaurantSettings = async ({ restaurantId, body }) => {
	const response = await authenticatedApi.patch(
		`${MICROSERVICE_CONFIG.ACCOUNTING}/restaurant/${restaurantId}/configs`,
		body
	);
	return response.data;
};

export const getRestaurantSettings = async (restaurantId) => {
	const response = await authenticatedApi.get(
		`${MICROSERVICE_CONFIG.ACCOUNTING}/restaurant/${restaurantId}/configs`
	);
	return response.data;
};

export const downloadRestaurants_api = async (params) => {
	const response = await authenticatedApi.post(
		`${MICROSERVICE_CONFIG.RESTAURANT}/download/restaurants`,
		params
	);
	return response.data;
};

export const getOrderByRestaurant_api = async (id) => {
	if (id) {
		const response = await authenticatedApi.get(
			`${MICROSERVICE_CONFIG.ACCOUNTING}/orders/restaurant/${id}`
		);
		return response.data;
	}
};

export const deactivateRestaurant_api = async (id) => {
	const response = await authenticatedApi.post(
		`${MICROSERVICE_CONFIG.AUTH}/admin/restaurant/${id}/deactivate`
	);
	return response.data;
};

export const reactivateRestaurant_api = async (id) => {
	const response = await authenticatedApi.post(
		`${MICROSERVICE_CONFIG.AUTH}/admin/restaurant/${id}/reactivate`
	);
	return response.data;
};

export const getFranchiseStores_api = async (payload) => {
	const response = await authenticatedApi.get(
		`${MICROSERVICE_CONFIG.RESTAURANT}/restaurants/franchise/stores/${payload.restaurantId}?${payload.params}`
	);
	return response.data;
};

export const updateBusinessType_api = async (payload) => {
	const { restaurantId, body } = payload;
	const response = await authenticatedApi.post(
		`${MICROSERVICE_CONFIG.AUTH}/admin/restaurant/${restaurantId}/business-type/change`,
		body
	);
	return response.data;
};

export const approveRestaurant_api = async (restaurantId) => {
	const response = await authenticatedApi.patch(
		`${MICROSERVICE_CONFIG.RESTAURANT}/restaurants/${restaurantId}/approve`
	);
	return response.data;
};

export const updateRestaurantGiftSettings = async (payload) => {
	const { body, restaurantId } = payload;
	const response = await authenticatedApi.patch(
		`${MICROSERVICE_CONFIG.RESTAURANT}/restaurants/${restaurantId}/configs`,
		body
	);
	return response.data;
};

export const getRestaurantTaxInfo = async (restaurantId) => {
	const response = await authenticatedApi.get(
		`${MICROSERVICE_CONFIG.ACCOUNTING}/restaurant/${restaurantId}/tax-information`
	);
	return response.data;
};

export const getTaxMasterRestaurant = async (restaurantId) => {
	const response = await authenticatedApi.get(
		`${MICROSERVICE_CONFIG.ACCOUNTING}/restaurant/${restaurantId}/taxable-restaurant`
	);
	return response.data;
};

export const updateTaxMasterRestaurant = async (payload) => {
	const { restaurantId, body } = payload;
	const response = await authenticatedApi.patch(
		`${MICROSERVICE_CONFIG.ACCOUNTING}/restaurant/${restaurantId}/taxable-restaurant`,
		body
	);
	return response.data;
};

export const getAllPartners_api = async () => {
	const response = await authenticatedApi.get(
		`${MICROSERVICE_CONFIG.AUTH}/restaurantS/partners`
	);
	return response.data;
};

export const addPartnership_api = async (payload) => {
	const { restaurantId, body } = payload;
	const response = await authenticatedApi.post(
		`${MICROSERVICE_CONFIG.AUTH}/restaurants/${restaurantId}/partners`,
		body
	);
	return response.data;
};

export const getPartnerships_api = async (id) => {
	const response = await authenticatedApi.get(
		`${MICROSERVICE_CONFIG.AUTH}/restaurants/${id}/partners`
	);
	return response.data;
};
